export const DEFAULT_LOCALE = "en-US";

// The base path of the Mons application route configured in Monster UI.
// Must match the Path of the route pointing at this app.
// @see https://monster.mons.amazon.dev/applications/HILTBusinessReportingUI
export const MONS_ROUTE_BASE = "/hilt-business-reporting";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// The dashboard + review this UI addresses. dashboardId is a closed enum on
// the service ("fai" = the FAI program); reviewType is required on every read
// operation. Together they name one served review (the FAI WBR). Multi-WBR
// selection will make these dynamic (ListDashboards).
export const WBR_DASHBOARD_ID = "fai";
export const WBR_REVIEW_TYPE = "WBR" as const;
